import { render, staticRenderFns } from "./addGameVideo.vue?vue&type=template&id=34d5971e&"
import script from "./addGameVideo.vue?vue&type=script&lang=js&"
export * from "./addGameVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34d5971e')) {
      api.createRecord('34d5971e', component.options)
    } else {
      api.reload('34d5971e', component.options)
    }
    module.hot.accept("./addGameVideo.vue?vue&type=template&id=34d5971e&", function () {
      api.rerender('34d5971e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/components/addGameVideo.vue"
export default component.exports